import BannerCentered from './BannerCentered';
export default BannerCentered;
